export type VariantProps<T extends (...args: any) => any> = Omit<
  Parameters<T>[0],
  'className'
>

export interface CVAConfig {
  variants?: Record<string, Record<string, string>>
  defaultVariants?: Record<string, string>
}

export function cva(base: string, config?: CVAConfig) {
  return ({ className = '', ...variants }: Record<string, string>) => {
    const classes = [base]
    if (config?.variants) {
      for (const key in variants) {
        const value = variants[key]
        const map = (config.variants as any)[key]
        if (map && map[value]) classes.push(map[value])
      }
    }
    if (className) classes.push(className)
    return classes.join(' ')
  }
}
